import { SET_REGION } from "../actions/actionTypes";


export const region = (state = '', action) => {
  switch (action.type) {
    case SET_REGION:
      return action.payload;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/region.js